import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import partnerService from 'services/partnerService';
import { openModal } from 'reducers/modalReducer';
import { PartnerType } from 'types/Partner';
import { isNotNullOrUndefined } from 'utils/utils';

export const useFetchPartnerEditHistory = (techId: string, partnerType: PartnerType) => {
  const dispatch = useDispatch();

  //todo this should be a real type instead of any
  const query = useQuery<any, AxiosError>({
    queryKey: ['fetchPartnerRevisionHistory', techId, partnerType],
    queryFn: () => partnerService.getRevisionHistoryData(techId, partnerType),
    gcTime: 0,
  });

  const { error, isError } = query;

  useEffect(() => {
    if (isError && isNotNullOrUndefined(error)) {
      dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            technicalInfo: {
              details: 'Error when fetching the revision history of the partner from pcm-partner-data-mgmt',
              title: 'Error when fetching the revision history of the partner',
              userErrorMessage: 'An error occurred while fetching the revision history of the partner',
            },
            httpError: error,
          },
        }),
      );
    }
  }, [isError, error, dispatch]);

  return query;
};
